export default "__VITE_ASSET__3TBrPamy__"